import React from 'react';

const ManageUsers = ({ users, updateData }) => {
  // Handle update functionality for each user
  const handleUserUpdate = (userId) => {
    const updatedUser = { ...users.find((user) => user.id === userId), name: 'Updated Name' }; // Update logic here
    updateData(updatedUser); // Call the passed function to update the user data
  };

  return (
    <div>
      <h3>Manage Users</h3>
      {users && users.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>
                  <button onClick={() => handleUserUpdate(user.id)}>Update</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No users found</p>
      )}
    </div>
  );
};

export default ManageUsers;
